import Cookies from 'js-cookie';
import { prop, compose, map, filter, test, keys, includes } from 'ramda';

import {
  GTAG,
  RGPD_SET_EVERYTHING,
  RGPD_SET_SETTINGS,
  RGPD_SET_VISIBLE,
  RGPD_SET_OPENED,
  RGPD_SET_FORCEDISPLAY,
} from '../../actions/rgpd';

const removeCookie = (...args) => Cookies.remove(...args); // for context preservation

const oneOfRGPDAction = (action) =>
  includes(action, [
    RGPD_SET_VISIBLE,
    RGPD_SET_SETTINGS,
    RGPD_SET_OPENED,
    RGPD_SET_FORCEDISPLAY,
  ]);

const filteredCookies = (reg) => filter(test(reg));
const GTAG_COOKIES = /^(?:_ga$|_gid$|_gat)/;

const removeGtagCookies = compose(
  map(removeCookie),
  filteredCookies(GTAG_COOKIES)
);

const reduce = (state, action) => {
  let res;

  // state should never be empty anyway
  switch (action.type) {
    case RGPD_SET_SETTINGS:
      res = {
        type: RGPD_SET_EVERYTHING,
        payload: {
          ...state,
          options: action.payload,
        },
      };
      break;

    case RGPD_SET_VISIBLE:
      res = {
        type: RGPD_SET_EVERYTHING,
        payload: {
          ...state,
          visible: action.payload,
        },
      };
      break;

    case RGPD_SET_OPENED:
      res = {
        type: RGPD_SET_EVERYTHING,
        payload: {
          ...state,
          opened: action.payload,
        },
      };
      break;

    case RGPD_SET_FORCEDISPLAY:
      res = {
        type: RGPD_SET_EVERYTHING,
        payload: {
          ...state,
          forceDisplay: action.payload,
        },
      };
      break;
  }

  if (!res.payload.options[GTAG] && state.options[GTAG]) {
    removeGtagCookies(keys(Cookies.get()));
  }

  return res;
};

/* istanbul ignore next */
const save = (options) => {
  try {
    Cookies.set('rgpd', JSON.stringify(options), {
      expires: 180,
      secure: true,
      httpOnly: false,
      path: '/',
    });
  } catch (e) {
    // eslint-disable-next-line
    console.error('There was an issue accessing localStorage');
  }
};

export default ({ getState }) =>
  (next) =>
  (action) => {
    const { type } = action;

    if (oneOfRGPDAction(type)) {
      const res = reduce(prop('rgpd', getState()), action);
      save(res.payload);

      return next(res);
    }

    return next(action);
  };
